import styled from 'styled-components';
import { Radio } from 'antd';

export const StyledRadioGroup = styled(Radio.Group)<{
  size: 'small' | 'large';
}>`
  .ant-radio-inner {
    width: 24px;
    height: 24px;
  }

  .ant-radio-wrapper
    .ant-radio-checked:not(.ant-radio-disabled)
    .ant-radio-inner {
    background-color: white !important;
    border-color: ${({ theme }) => theme.palette.secondary.main};
  }

  .ant-radio-wrapper
    .ant-radio-checked:not(.ant-radio-disabled)
    .ant-radio-inner::after {
    background-color: ${({ theme }) => theme.palette.secondary.main};
    width: 12px;
    height: 12px;
    margin-block-start: 0;
    margin-inline-start: 0;
    inset-block-start: 50%;
    inset-inline-start: 50%;
    transform: translate(-50%, -50%) !important;
    transition: none !important;
  }

  .ant-radio-inner {
    transition: none !important;
  }

  .ant-radio-inner::after {
    transition: none !important;
  }

  .ant-radio-wrapper .ant-radio:hover .ant-radio-inner {
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
  }

  .ant-radio-wrapper .ant-radio-input:focus + .ant-radio-inner {
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.secondary.main}33 !important;
  }

  .ant-radio-wrapper:hover:not(.ant-radio-disabled) {
    .ant-radio-inner {
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
    }
  }

  .ant-radio-wrapper .ant-radio-input:focus {
    outline: none;
  }

  .ant-radio-wrapper span.ant-radio + * {
    padding-inline-start: 10px;
    padding-inline-end: 10px;
  }

  .ant-radio-label {
    margin-top: 2px;
  }
`;
